import '../plugins/MobileNavPlugin.js';
import '../plugins/ResponsiveHelper.js';

// mobile menu init
export default function initMobileNav() {
	jQuery('body').mobileNav({
		menuActiveClass: 'nav-active',
		menuOpener: '.nav-opener',
		onShow: () => {
			togglePauseSmoother(true);

			jQuery(window).trigger('mobile-nav:show');
		},
		onHide: () => {
			togglePauseSmoother(false);

			jQuery(window).trigger('mobile-nav:hide');
		}
	});

	jQuery('body').mobileNav({
		menuActiveClass: 'navigation-active',
		menuOpener: '.navigation-main-opener'
	});

	function togglePauseSmoother(state) {
		const smoother = window.ScrollSmoother ? ScrollSmoother.get() : null;

		if (smoother) {
			smoother.paused(state);
		}
	}
}
